import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { HttperrorhandlerService } from 'src/app/main/shared/http/httperrorhandler.service';
import { catchError } from 'rxjs/operators';
import * as Highcharts from 'highcharts';
import { environment } from 'src/environments/environment';
import { isNullOrUndefined } from 'util';
import { UtilsService } from 'src/app/utils/utils.service';

@Injectable({
  providedIn: 'root'
})
export class FloodForecastDataService {

  API_URL = environment.url.HEATWAVE_STAGING_API_URL; // Staging link
  // APWRIMS_URL : "http://kaleshwaram.vassarlabs.com/api",
  STAGING_API_URL = environment.url.KALESHWARAM_API_URL;
  WRIS_API_URL = environment.url.KALESHWARAM_WRIS_API_URL;
  API = 'http://kaleshwaram.vassarlabs.com/api';
  APWRIMS_URL = 'http://apwrims.ap.gov.in/api';
  urlConstants = environment.url;

  lasttwoyearReturnValue: any ;
  lastfiveYearReturnValue : any;
  lasttwentyYearReturnValue:any;
  sourceDataAlert:any = 'IMD_RADAR_NOWCAST';
  constructor(
    private http: HttpClient,
    private errorHandler: HttperrorhandlerService,
    public utils: UtilsService,
  ) { }

  getWindData(url: string) {
    const dataPromise = new Promise((resolve) => {
      this.http.get(url).subscribe(
        data => {
          const obj = this.setWindData(data);
          resolve(obj);
        }
      );
    });
    return dataPromise;
  }

  getRainfallHeatMapData(url, options: object): Observable<any> {
    const heatMapUrl = url;
    return this.http.post<any>(environment.url.PLAY_URL + heatMapUrl, options).pipe(
      catchError(this.errorHandler.handleError('error in Heatmap data request', []))
    );
  }

  getTimestampData(): Observable<any> {
    return this.http.get<any>(environment.url.HEATWAVE_STAGING_API_URL + 'nowcast/getHeatMapData/NOWCAST').pipe(
      catchError(this.errorHandler.handleError('Date range request for ', []))
    );
  }

  getSourceListForComponent(options): Observable<any> {
    return this.http.post<any>(environment.url.PLAY_URL + 'comm/getrankwisesource', options).pipe(
      catchError(this.errorHandler.handleError('All Sources data for Components : ', []))
    );
  }

  getDateRangeForComponent(component: string, source: string): Observable<any> {
    return this.http.get<any>(environment.url.PLAY_URL + 'comm/range2/' + component + '/' + source).pipe(
      catchError(this.errorHandler.handleError('Date range request for ' + component, []))
    );
  }

  getHeatMap(url: string) {
    const dataPromise = new Promise((resolve) => {
      this.http.get(url).subscribe(
        data => {
          const obj = this.setMapData(data);
          resolve(obj);
        });
    });
    return dataPromise;
  }

  getSummaryData(postData) {
    let summaryUrl = this.urlConstants.temp2 + "nowcast/resCatchment";
    return this.http.post(summaryUrl, postData);
  }

  getMarkersColorsPostData(source: string): any {
    let today = new Date() ;
    let timestamp;
    let sDate = new Date();
    sDate.setHours(8);
    sDate.setMinutes(30);
    sDate.setSeconds(0);
    sDate.setMilliseconds(0);
    let sDateTimestamp=sDate.getTime();
    timestamp=today.getTime();     
    let postData = {
      "pUUID": "00cb31c7-2928-4e6d-adcc-443d478c90d6",
      "pEUUID": "00cb31c7-2928-4e6d-adcc-443d478c90d6",
      "pType": "COUNTRY",
      "src": "STATE_AND_CENTRAL_STATIONS",
      "cType":"RESERVOIR",
      "format": "DAILY",
      "sDate": sDateTimestamp,
      "eDate": timestamp,
      "rfSrc" : this.sourceDataAlert,
      "widgetsTypeList": ["normal"],
      "classification": [
          "INSTANT_DATA"
      ]
  }
  return postData;
  }

  getAllMarkersColourInfo(postData) {
    let api = this.urlConstants.temp2 + "nowcast/flowwidgets/detaileddata";
    return this.http.post<any>(api, postData);
  }

  setMapData(data: object) {
    const obj = {};
    let imageUrl = {};
    const imageBounds = [];
    for (const block of Object.keys(data)) {
      for (const { } of Object.keys(data[block])) {
        imageUrl = data[block]['heatMapImage'];
        let latlongs = [];
        latlongs.push(data[block]['heatMapImageBound']['southWest']['latitude']);
        latlongs.push(data[block]['heatMapImageBound']['southWest']['longitude']);
        imageBounds.push(latlongs);
        latlongs = [];
        latlongs.push(data[block]['heatMapImageBound']['northEast']['latitude']);
        latlongs.push(data[block]['heatMapImageBound']['northEast']['longitude']);
        imageBounds.push(latlongs);
      }
      obj['url'] = imageUrl;
      obj['bounds'] = imageBounds;
    }
    return obj;
  }

  getMaxMin2(arr) {
    var max = -10, min = 10000000;
    for (var index = 0; index < arr.length; index++) {
      if (arr[index][1] && (min > arr[index][1])) {
        min = arr[index][1];
      }
      if (arr[index][1] && (max < arr[index][1])) {
        max = arr[index][1];
      }
    }
    return ([max, min])
  }

  setWindData(data: Object) {
    for (const block of Object.keys(data)) {
      const array = [];
      const obj1 = new Object();
      obj1['header'] = {
        parameterUnit: 'm.s-1',
        parameterNumber: 2,
        dx: 0.5,
        dy: 0.5,
        parameterNumberName: 'eastward_wind',
        la1: 40.0,
        la2: 5.0,
        parameterCategory: 2,
        lo2: 100.0,
        nx: 71,
        ny: 71,
        refTime: '2017-02-01 23:00:00',
        lo1: 65.0
      };
      obj1['data'] = data[block]['data1'];
      array[0] = obj1;

      const obj2 = {};
      obj2['header'] = {
        parameterUnit: 'm.s-1',
        parameterNumber: 3,
        dx: 0.5,
        dy: 0.5,
        parameterNumberName: 'eastward_wind',
        la1: 40.0,
        la2: 5.0,
        parameterCategory: 2,
        lo2: 100.0,
        nx: 71,
        ny: 71,
        refTime: '2017-02-01 23:00:00',
        lo1: 65.0
      };
      obj2['data'] = data[block]['data2'];
      array[1] = obj2;
      return array;
    }
  }

  // kaleshwaram api
  // getMetaDataForAllPoints(): Observable<any> {
  //   return this.http.get<any>(this.API_URL + 'flowmanagement/masterdata/root/3a7a18ff-8614-4c90-aa98-451b333df3d9').pipe(
  //     catchError(this.errorHandler.handleError('Kpi data request', []))
  //   );/nowcast/getReservoirDetail/00cb31c7-2928-4e6d-adcc-443d478c90d6
  // }

  getMetaDataForAllPoints(): Observable<any> {
    return this.http.get<any>(this.API_URL + 'nowcast/getReservoirDetail/00cb31c7-2928-4e6d-adcc-443d478c90d6').pipe(
      catchError(this.errorHandler.handleError('Kpi data request', []))
    );
  }

  getStationRainfallData(options: object): Observable<any> {
    return this.http.post<any>(this.WRIS_API_URL + 'rf/aggregated', options).pipe(
      catchError(this.errorHandler.handleError('Kpi data request', []))
    );
  }

  getNewRainfallGisChart(postData) {
    return this.http.post<any>(this.WRIS_API_URL + 'rf/timeseries', postData).pipe(
      catchError(this.errorHandler.handleError('Kpi data request', []))
    );
  }

  getCurrForecastGraphData(postData) {
    if (!isNullOrUndefined(postData.ishecrasData)) {
      return this.http.get<any>(this.STAGING_API_URL + "hecras/flowmanagement/pointdata/root/3a7a18ff-8614-4c90-aa98-451b333df3d9/" + postData.pointName + "/LASTKNOWN/" + postData.refTs + "/0/" + postData.hercastab)
    }
    else {
      let pointName = postData.pointName;
      let refTs = postData.refTs;
      let useActualVICR = postData.useActualVICR;
      let useForecastVICR = postData.useForecastVICR;
      let useGuageData = postData.useGuageData;
      return this.http.get<any>(this.STAGING_API_URL + "flowmanagement/pointdata/root/3a7a18ff-8614-4c90-aa98-451b333df3d9/view/DAILY/" + pointName + "/" + refTs + "/" + useActualVICR + "/" + useForecastVICR + "/" + useGuageData);
    }
  }

  getCurrForecastGraphService(postData) {
    const pointName = postData.pointName;
    const refTs = postData.refTs;
    const useActualVICR = postData.useActualVICR;
    const useForecastVICR = postData.useForecastVICR;
    const useGuageData = postData.useGuageData;
    // return this.httpClient.get<any>(this.urlConstants.API_URL +"/flowmanagement/pointdata/root/3a7a18ff-8614-4c90-aa98-451b333df3d9/view/DAILY/" + pointName + "/" + refTs + "/" + useActualVICR + "/" + useForecastVICR + "/" + useGuageData);
    return this.http.get<any>(this.API_URL + 'flowmanagement/pointdata/root/3a7a18ff-8614-4c90-aa98-451b333df3d9/view/DAILY/' + pointName + '/' + refTs + '/' + useActualVICR + '/' + useForecastVICR + '/' + useGuageData).pipe(
      catchError(this.errorHandler.handleError('Kpi data request', []))
    );
  }


  //Here!
  getCurrForecastActualGraphData(postData) {
    if (postData.pType == "RIVER_GAUGE") {
      return this.http.post<any>(this.WRIS_API_URL + 'rivergauge/timeseries', postData);
    }
    if (postData.pType == "RESERVOIR") {
      return this.http.post<any>(this.WRIS_API_URL + 'reservoir/timeseries', postData);
    }
  }

  getCompareGraphService(postData) {
    if (!isNullOrUndefined(postData.ishecrasData)) {
      return this.http.get<any>(this.API_URL + "hecras/flowmanagement/pointdata/root/3a7a18ff-8614-4c90-aa98-451b333df3d9/" + postData.pointName + "/LASTKNOWN/" + postData.refTs + "/0/" + postData.hercastab)
    }
    else {
      const pointName = postData.pointName;
      const refTs = postData.refTs;
      const accuracy = postData.accuracy;
      const useActualVICR = postData.useActualVICR;
      const useForecastVICR = postData.useForecastVICR;
      const useGuageData = postData.useGuageData;
      return this.http.get<any>(this.API_URL + 'flowmanagement/chart/comparison/root/3a7a18ff-8614-4c90-aa98-451b333df3d9/' + pointName + '/' + refTs + '/' + accuracy + '/' + useActualVICR + '/' + useForecastVICR + '/' + useGuageData).pipe(
        catchError(this.errorHandler.handleError('Kpi data request', []))
      );
    }
  }

  getHistoricalGraphService(postData) {
    if (!isNullOrUndefined(postData.ishecrasData)) {
      return this.http.get<any>(this.STAGING_API_URL + "hecras/flowmanagement/pointdata/root/3a7a18ff-8614-4c90-aa98-451b333df3d9/" + postData.pointName + "/" + postData.startTs + "/" + postData.snapshotTs + "/0/" + postData.hercastab);
    }
    else {
      const pointName = postData.pointName;
      const snapshotTs = postData.snapshotTs;
      const startTs = postData.startTs;
      const useActualVICR = postData.useActualVICR;
      const useForecastVICR = postData.useForecastVICR;
      const useGuageData = postData.useGuageData;
      // return this.httpClient.get<any>(this.urlConstants.API_URL + "/flowmanagement/pointdata/history/root/3a7a18ff-8614-4c90-aa98-451b333df3d9/" + pointName + "/" + snapshotTs + "/" + startTs + "/" + useActualVICR + "/" + useForecastVICR + "/" + useGuageData);
      return this.http.get<any>(this.STAGING_API_URL + 'flowmanagement/pointdata/history/root/3a7a18ff-8614-4c90-aa98-451b333df3d9/' + pointName + '/' + startTs + '/' + snapshotTs + '/' + useActualVICR + '/' + useForecastVICR + '/' + useGuageData).pipe(
        catchError(this.errorHandler.handleError('Kpi data request', []))
      );
    }
  }

  getEnsembleGraphService(postData) {
    const pEUUID = postData.pointUUID;
    const endTs = postData.endTs;
    const startTs = postData.startTs;
    // return this.httpClient.get<any>(this.urlConstants.API_URL + "/flowmanagement/getEnsembleForecastData/" + pointName + "/" + startTs + "/" + endTs);
    // return this.http.get<any>(this.API_URL + 'flowmanagement/getEnsembleForecastData/' + pointName + '/' + startTs + '/' + endTs).pipe(
    //   catchError(this.errorHandler.handleError('Kpi data request', []))
    // );
    return this.http.get<any>(environment.url.KALESHWARAM_WRIS_API_URL+"glofas/"+"9553a7af-56f8-495f-ba0c-c2d2324e6759"+"/"+pEUUID+"/"+"hms_combined/"+ startTs + '/' + endTs).pipe(
      catchError(this.errorHandler.handleError('Kpi data request', []))
    );
  }

  getObservedForecastRF(pointName, startdate, endDate) {
    const RF_URL = this.API_URL + 'flowmanagement/rainfall/data/3a7a18ff-8614-4c90-aa98-451b333df3d9/' + pointName + '/' + startdate + '/' + endDate + '/69';
    return this.http.get<any>(RF_URL);
  }

  getEnsembleGraphNew(dataForChart, plotBandData, ymax, that) {
        if(ymax==0)
        ymax=100
    Highcharts.setOptions({
        time: {
        useUTC: false
        }
    });

    const options: object = {
        chart: {
        zoomType: 'xy',
        backgroundColor: '#171e28',
        type: 'areasplinerange'
        },
        title: {
        text: '',
        style: {
            color: 'white'
        }
        },
        subtitle: {
        // text: ''
        },
        plotOptions: {
        areasplinerange : {
            lineWidth: 0,
            shadow: false,
            marker: {
                enabled: false
            },
            enableMouseTracking: false,
            showInLegend: false
        },
        spline: {
            zIndex: 5,
            marker:{
                enabled:false
            }
        },
        series: {
            marker: {
            enabled: false
            },
            states: {
            hover: {
                enabled: true,

            },
            inactive: {
                enabled: false
            }
            },
            connectNulls: true
        }
        },
        xAxis: [{
        crosshair: true,
        type: 'datetime',
        plotLines: [{
            color: '#000000', // Color value
            // value: this.getLineInPumpchart(object[2]), // Value of where the line will appear
            width: 0.90,
            zIndex:4,
            dashStyle: 'ShortDash'
        }],
        labels: {
            step:2,

            style: {
            color: 'white',
            fontSize: '13px',
            margin: 100
    //width:'1px',
            
            },
            format: '{value:%e-%b-%Y}'

        }

        }],
        yAxis: [
        {
            min: 0,
            max : 1.3 * ymax,
            gridLineColor: 'rgba(255, 255, 255, 0.1)',
            title: {
            text: 'Flow (Cusecs)',
            style: {
                color: 'white'
            }
            },
            labels: {
            style: {
                color: 'white'
            }
            },
            plotBands: plotBandData,
        }
        ],
        tooltip: {
        enabled: true,
        shared: false,
        formatter() {
            let value = 'Date: <b>' + that.getSimpleDateString(this.x) + '<br>';
            value = value + 'InFlow: <b>' + this.y + ' cusecs</b>' + '<br>';
            value = value + 'Ensemble No.: <b>' + this.series.name + '<br>';
            return value;
        }
        },
        legend: {
        itemStyle: {
            color: 'white'
        }
        },
        series: dataForChart,
        colors: ['rgb(67, 67, 72)'],
        exporting: {
        enabled: false
        },
        credits: {
        enabled: false
        }

    };

    return options;
  }

  formatEnsembleData(response) {
   let meanData:any[] = this.getEnsembleInflowValuesFromAPIResponseNew(response["-1"]);
      let dependabilty75Data:any[] = this.getEnsembleInflowValuesFromAPIResponseNew(response["-3"]);
      let dependabilty25Data:any[] = this.getEnsembleInflowValuesFromAPIResponseNew(response["-2"]);
      let deterministicData:any[] = this.getEnsembleInflowValuesFromAPIResponseNew(response["-8"]);
      let imdForecastData:any[] = this.getEnsembleInflowValuesFromAPIResponseNew(response["-7"]);
      let gaugeData:any[] = this.getEnsembleInflowValuesFromAPIResponseNew(response["-9"]);
      let actualgaugeData:any[] = this.getEnsembleInflowValuesFromAPIResponseNew(response["-10"]);
      let ensembleData ={};
      let timeStamps =[];

      for(let timeStamp in response["0"]){
        if(!timeStamps.includes(timeStamp)) timeStamps.push(timeStamp);
      }
      timeStamps.sort();

      this.lastfiveYearReturnValue = null;
      this.lasttwentyYearReturnValue = null;
      this.lasttwoyearReturnValue = null;
      let fiveYearReturnValue;
      let twoYearReturnValue;
      let twentyYearReturnValue;
      let ymax;
      for(let timeStamp of timeStamps){
        if(response["-4"] && response["-4"][timeStamp]){
          twoYearReturnValue = response["-4"][timeStamp].in;
          break;
        }
      }
      for(let timeStamp of timeStamps){
        if(response["-5"] && response["-5"][timeStamp]){
          fiveYearReturnValue = response["-5"][timeStamp].in;
          break;
        }
      }
      for(let timeStamp of timeStamps){
        if(response["-6"] && response["-6"][timeStamp]){
          twentyYearReturnValue = response["-6"][timeStamp].in;
          break;
        }
      }
      if(isNullOrUndefined(this.lasttwoyearReturnValue)){
        this.lasttwoyearReturnValue = twoYearReturnValue;
      }
      if(isNullOrUndefined(this.lastfiveYearReturnValue)){
        this.lastfiveYearReturnValue = fiveYearReturnValue;
      }
      if(isNullOrUndefined(this.lasttwentyYearReturnValue)){
        this.lasttwentyYearReturnValue = twentyYearReturnValue;
      }

      ymax = this.lastfiveYearReturnValue;
      if(ymax == undefined){
        ymax = this.lasttwoyearReturnValue;
      }

      // for(let timeStamp in response["-2"]){
      //   let val = response["-2"][timeStamp].in;
      //   if(isNullOrUndefined(ymax) ||  (val > ymax)){
      //     ymax = val;
      //   }
      // }
      meanData.sort((a,b) => { return a[0]-b[0]})
      dependabilty75Data.sort((a,b) => { return a[0]-b[0]})
      dependabilty25Data.sort((a,b) => { return a[0]-b[0]})
      deterministicData.sort((a,b) => {return a[0] - b[0]})
      imdForecastData.sort((a,b) => {return a[0] - b[0]})
      gaugeData.sort((a,b) => {return a[0] - b[0]})
      actualgaugeData.sort((a,b) => {return a[0] - b[0]})
      
      for(let ensembleNo in response){
        if(Number(ensembleNo) == -4 || Number(ensembleNo) == -5 || Number(ensembleNo) == -6 || Number(ensembleNo) == -7)
        {
          continue;
        }
        let ensembleNoData = response[ensembleNo];
        for(let timeStamp in ensembleNoData){
          if(!ensembleData[timeStamp]) ensembleData[timeStamp] =[];
            
          if(ensembleNoData[timeStamp]['in']){
               if(isNullOrUndefined(ymax)){
                
                 ymax = ensembleNoData[timeStamp]['in'];
               }else if(parseFloat(ymax) < parseFloat( ensembleNoData[timeStamp]['in'])){
                 ymax =  ensembleNoData[timeStamp]['in'];
               }
          }
          ensembleData[timeStamp].push(Number(Number(ensembleNoData[timeStamp]['in']).toFixed(2)));
        }
      }
      for(let timeStamp in ensembleData){
        ensembleData[timeStamp].sort((a,b) => a - b)
      }
      let ensemblePercentileData ={}
      let medianData = []

      for(let timeStamp of timeStamps){
          let dateForTimeStamp = new Date(Number(timeStamp));   
          let roundedTimeStamp = timeStamp;
          let median_index = this.calculatePercentile(ensembleData[timeStamp],50);
          if(median_index == -1){
            continue;
          }


          if(ensembleData[timeStamp].length <= median_index) continue;
          let medianValue =  Number(Number(ensembleData[timeStamp][median_index]).toFixed(2));
          medianData.push([Number(roundedTimeStamp),medianValue]);

          let ninetyPercentileIndex = this.calculatePercentile(ensembleData[timeStamp],100);

         // ninetyPercentileIndex= ninetyPercentileIndex+1;

          if(!isNullOrUndefined(ensembleData[timeStamp][ninetyPercentileIndex])){
            let ninetyPercentilValue = ensembleData[timeStamp][ninetyPercentileIndex];
            if(isNullOrUndefined(ymax) ||  (ninetyPercentilValue > ymax) || ymax =='-'){
              ymax = ninetyPercentilValue;
            }
          }

          for(let i=0;i <= 100; i++){
            let index = this.calculatePercentile(ensembleData[timeStamp],i);
            if(!ensemblePercentileData[i]){
              ensemblePercentileData[i] = [];
            }

            ensemblePercentileData[i].push([Number(roundedTimeStamp),  Number(Number(ensembleData[timeStamp][index]).toFixed(2)), medianValue]);
            
          }
      }


      for(let i=0;i <= 100; i++ ){
        if(ensemblePercentileData[i]){
          ensemblePercentileData[i].sort((a,b) => {return (a[0] - b[0])})
        }
      }

      medianData.sort((a,b) => {return (a[0] - b[0])});

      if(isNullOrUndefined(this.lasttwoyearReturnValue)){
        this.lasttwoyearReturnValue = twoYearReturnValue;
      }
      if(isNullOrUndefined(this.lastfiveYearReturnValue)){
        this.lastfiveYearReturnValue = fiveYearReturnValue;
      }
      if(isNullOrUndefined(this.lasttwentyYearReturnValue)){
        this.lasttwentyYearReturnValue = twentyYearReturnValue;
      }

      return [medianData,ensemblePercentileData,timeStamps,meanData,dependabilty25Data,dependabilty75Data,twoYearReturnValue,fiveYearReturnValue,twentyYearReturnValue,ymax,deterministicData,imdForecastData,gaugeData,actualgaugeData]
  }

  getEnsmblePlotbands(twoYearReturnValue, fiveYearReturnValue, twentyYearReturnValue) {
    let values = [twoYearReturnValue, fiveYearReturnValue, twentyYearReturnValue];
    let plotBandData = [
      {
        color: 'rgb(256,256,256)', // Color value
        from: 0, // Start of the plot band
        zIndex: 2,
        to: twoYearReturnValue, // End of the plot band
      },
      {
        color: 'rgb(242, 242, 204)', // Color value
        zIndex: 2,
        label: {
          text: "2-year return period value",
          align: 'right',
          verticalAlign: 'bottom',
          style: {
            color: 'black'
          },
          x: -7,
          y: -2,
        },
      },

      {
        color: 'rgb(249, 203, 203)', // Color value
        zIndex: 2,
        label: {
          text: "5-year return period value",
          align: 'right',
          verticalAlign: 'bottom',
          style: {
            color: 'black'
          },
          x: -7,
          y: -2,
        },
      },
      {
        color: 'rgb(229, 204, 254)', // Color value
        zIndex: 2,
        label: {
          text: "20-year return period value",
          align: 'right',
          verticalAlign: 'bottom',
          style: {
            color: 'black'
          },
          x: -7,
          y: -2,
        }
      },
    ]
    let plotBands = [];
    plotBands.push(plotBandData[0]);
    let index = 1;
    let newArrayIndex = 0;
    for (let value of values) {
      if (!isNullOrUndefined(value)) {
        plotBands[newArrayIndex].to = value;
        plotBands.push(plotBandData[index]);
        newArrayIndex = newArrayIndex + 1;
        plotBands[newArrayIndex].from = value;
      }
      index += 1;
    }
    plotBands[newArrayIndex].to = 10000000000;
    return plotBands;
  }

  calculatePercentile(arr: [], percentile): Number {
    if (percentile == 0) return 0;
    let index = Number(((percentile * arr.length) / 100).toFixed(0));
    return index > 0 ? index - 1 : 0
  }

  getEnsembleAPIResponse(data){
     let returnData = []
    for (let timeStamp in data) {
      let dateForTimeStamp = new Date(Number(timeStamp));
      dateForTimeStamp.setHours(0);
      dateForTimeStamp.setMinutes(0);
      dateForTimeStamp.setSeconds(0);
      dateForTimeStamp.setMilliseconds(0);
      let roundedTimeStamp = dateForTimeStamp.getTime();
      returnData.push([Number(roundedTimeStamp), Number(Number(data[timeStamp]['0']).toFixed(2))]);
    }
    return returnData
  }

   getEnsembleInflowValuesFromAPIResponseNew(data){
      let returnData = []
      if(isNullOrUndefined(data)){
          return returnData;
      }
      for(let timeStamp in data){
        let dateForTimeStamp = new Date(Number(timeStamp));
        let roundedTimeStamp = timeStamp;
        returnData.push([Number(roundedTimeStamp),Number(Number(data[timeStamp]['in']).toFixed(2))]);
      }
      return returnData
    }

  getEnsembleInflowValuesFromAPIResponse(data) {
    let returnData = []
    for (let timeStamp in data) {
      let dateForTimeStamp = new Date(Number(timeStamp));
      dateForTimeStamp.setHours(0);
      dateForTimeStamp.setMinutes(0);
      dateForTimeStamp.setSeconds(0);
      dateForTimeStamp.setMilliseconds(0);
      let roundedTimeStamp = dateForTimeStamp.getTime();
      returnData.push([Number(roundedTimeStamp), Number(Number(data[timeStamp]['-1']).toFixed(2))]);
    }
    return returnData
  }
  getEnsemble25DepFromAPIResponse(data) {
    let returnData = []
    for (let timeStamp in data) {
      let dateForTimeStamp = new Date(Number(timeStamp));
      dateForTimeStamp.setHours(0);
      dateForTimeStamp.setMinutes(0);
      dateForTimeStamp.setSeconds(0);
      dateForTimeStamp.setMilliseconds(0);
      let roundedTimeStamp = dateForTimeStamp.getTime();
      returnData.push([Number(roundedTimeStamp), Number(Number(data[timeStamp]['-2']).toFixed(2))]);
    }
    return returnData
  }
  getEnsemble75DepFromAPIResponse(data) {
    let returnData = []
    for (let timeStamp in data) {
      let dateForTimeStamp = new Date(Number(timeStamp));
      dateForTimeStamp.setHours(0);
      dateForTimeStamp.setMinutes(0);
      dateForTimeStamp.setSeconds(0);
      dateForTimeStamp.setMilliseconds(0);
      let roundedTimeStamp = dateForTimeStamp.getTime();
      returnData.push([Number(roundedTimeStamp), Number(Number(data[timeStamp]['-3']).toFixed(2))]);
    }
    return returnData
  }

  getEnsembleGraph(dataForChart, that) {
    Highcharts.setOptions({
      time: {
        useUTC: false
      }
    });
    const options: object = {
      chart: {
        zoomType: 'xy',
        backgroundColor: '#2986cc',
        type: 'line'
      },
      title: {
        text: '',
        style: {
          color: 'white'
        }
      },
      subtitle: {
        // text: ''
      },
      plotOptions: {
        series: {
          marker: {
            enabled: false
          },
          states: {
            hover: {
              enabled: true,

            },
            inactive: {
              enabled: false
            }
          },
          connectNulls: true
        }
      },
      xAxis: [{
        crosshair: true,
        type: 'datetime',
        plotLines: [{
          // color: 'red', // Color value
          // value: this.getLineInPumpchart(object[2]), // Value of where the line will appear
          // width: 0.90,
          // zIndex:3,
          // dashStyle: 'ShortDash'
        }],
        labels: {
          style: {
            color: 'white'
          },
          format: '{value:%e-%b-%Y}'

        }

      }],
      yAxis: [
        {
          min: 0,
          gridLineColor: 'rgba(255, 255, 255, 0.1)',
          title: {
            text: 'Flow (Cusecs)',
            style: {
              color: 'white'
            }
          },
          labels: {
            //    format: '{value}',
            style: {
              color: 'white'
            }
          }

        }
      ],
      tooltip: {
        enabled: true,
        shared: false,
        formatter() {
          let value = 'Date: <b>' + that.getSimpleDateString(this.x) + '<br>';
          value = value + 'InFlow: <b>' + this.y + ' cusecs</b>' + '<br>';
          value = value + 'Ensemble No.: <b>' + this.series.name + '<br>';
          return value;
        }
      },
      legend: {
        itemStyle: {
          color: 'white'
        }
      },
      series: dataForChart,
      colors: ['#87CEFA'],
      exporting: {
        enabled: false
      },
      credits: {
        enabled: false
      }

    };
    return options;
  }

  getLvlForecastGraph(object, that) {
    Highcharts.setOptions({
      time: {
        useUTC: false
      }
    });

    const options: object = {
      chart: {
        zoomType: 'xy',
        backgroundColor: '#171e28'
      },
      title: {
        text: '',
        style: {
          color: 'white'
        }
      },
      subtitle: {
      },
      xAxis: [{
        type: 'datetime',
        crosshair: true,
        plotLines: [{
          color: 'white', // Color value
          value: that.timeStepIndexValue, // Value of where the line will appear
          width: 0.90,
          zIndex: 3,
          dashStyle: 'ShortDash'
        }],
        labels: {
          style: {
            color: 'white'
          },
          format: '{value:%e-%b-%Y}'
        }

      }],
      yAxis: [
        {
          gridLineColor: 'rgba(255, 255, 255, 0.1)',
          title: {
            text: 'Water Level (meters)',
            style: {
              color: 'white'
            }
          },
          min: 0,
          // max: that.maxy1,
          labels: {
            // Hiding the negative labels in y-axis
            formatter() {
              if (this.value < 0) { return ''; }
              return this.value;
            },
            style: {
              color: 'white'
            }
          }
        }
      ],
      tooltip: {
        shared: true,
        valueDecimals: 2,
        valueSuffix: 'm'
      },
      plotOptions: {
        series: {
          pointPlacement: 'on',
          allowPointSelect: true,
          point: {
            events: {
              select(e) {
                this.updateIn = e.target.category;
                that.showDetailTable = true;
                that.showTable(this.updateIn);
              }
            }
          },
          connectNulls: true
        },
        column: {
          grouping: false
        }
      },
      legend: {
        itemStyle: {
          color: 'white'
        }
      },
      series: object,
      exporting: {
        enabled: false
      },
      credits: {
        enabled: false
      }

    };
    return options;
  }

  getCurrForecastGraph(object, that) {
    // that.maxy1 = 20194.93
     Highcharts.setOptions({
        time: {
            useUTC: false
        }
    });
   
    let options: object = {
      chart: {
        zoomType: 'xy',
        type:'spline',
        backgroundColor: '#343a40'
    },
    title: {
        text: '',
        style: {
            color : 'white'
        }
    },
    subtitle: {
    },
    xAxis: [{
        type: 'datetime',
        crosshair: true,
        plotLines: [{
            color: 'white', // Color value
            value: that.timeStepIndexValue, // Value of where the line will appear
            width: 0.90,
            zIndex:3,
            dashStyle: 'ShortDash'
          }],
        labels: {
                style: {
                    color: 'white'
                },
                format: '{value:%e-%b-%Y}'
            }
        
    }],
    yAxis: [
        { 
        gridLineColor: 'rgba(255, 255, 255, 0.1)',
        title: {
            text: 'Flow (Cusecs)',
            style: {
                color: 'white'
            }
        },
        min: that.vicParams == "HEC_HMS" ?  (that.maxy1<0 ? that.maxy1: -(0.7*that.maxy1)) : null,
        max: that.vicParams == "HEC_HMS" ? (that.maxy1<0? -(that.maxy1) : that.maxy1) : null,
        labels: {
            // Hiding the negative labels in y-axis
            formatter: function() {
              if ( this.value < 0  ) { return ''; }
              return this.value;
            },
            style: {
                color: 'white'
            }
          }
    },
    { 
        gridLineColor: 'rgba(255, 255, 255, 0.1)',
        title: {
            text: 'Storage (TMC)',
            style: {
                color: 'white'
            }
        },
        labels: {
            style: {
                color: 'white'
            }
        },
        max: that.maxy2,
        opposite: true
    }
],
    tooltip: {
        shared: true,
    },
    plotOptions:{
        series: {
            pointPlacement: 'on',
            allowPointSelect: true,
            point: {
              events: {
                select: function (e) {
                    this.updateIn = e.target.category;
                    that.showDetailTable = true;
                    that.showTable(this.updateIn);
                }
              }
            },
            connectNulls: true
          },
          column: {
            grouping: false        
        }
    },
    legend: {
        itemStyle: {
            color: 'white'
        }
    },
    series: object,
    exporting: {
        enabled: false
    },
    credits: {
        enabled: false
    }
   
    }
    return options;
  }

  getCompareGraph(dataForChart) {
    Highcharts.setOptions({
      time: {
        useUTC: false
      }
    });
    const options: object = {
      chart: {
        zoomType: 'xy',
        backgroundColor: '#171e28'
      },
      title: {
        text: '',
        style: {
          color: 'white'
        }
      },
      subtitle: {
        // text: ''
      },
      xAxis: [{
        crosshair: true,
        type: 'datetime',
        plotLines: [{
          color: 'white', // Color value
          // value: this.getLineInPumpchart(object[2]), // Value of where the line will appear
          width: 0.90,
          zIndex: 3,
          dashStyle: 'ShortDash'
          // shadow: true
          // label: {
          //   text: 'Current TimeStep',
          //   verticalAlign: 'middle',
          //   textAlign: 'center'
          // }
        }],
        labels: {
          style: {
            color: 'white'
          },
          format: '{value:%e-%b-%Y}'

        }

      }],
      yAxis: [
        {
          gridLineColor: 'rgba(255, 255, 255, 0.1)',
          title: {
            text: 'Flow (Cusecs)',
            style: {
              color: 'white'
            }
          },
          labels: {
            //    format: '{value}',
            style: {
              color: 'white'
            }
          }

        }
      ],
      tooltip: {
        shared: true
      },
      plotOptions: {
        series: {
          connectNulls: true
        }
      },
      legend: {
        itemStyle: {
          color: 'white'
        }
      },
      series: dataForChart,
      colors: ['#FFA500', '#1e88e5'],
      exporting: {
        enabled: false
      },
      credits: {
        enabled: false
      }

    };
    return options;
  }

  getCatchmentStationRainfallGraph(object) {
    const options: object = {
      chart:
      {
        zoomType: 'xy',
        backgroundColor: '#171e28'
      },
      title:
      {
        text: '',
        style:
        {
          color: 'white'
        }
      },
      subtitle:
      {
        // text: ''
      },

      xAxis:
        [{
          categories: object[1],
          crosshair: true,
          tickInterval: 0,

          labels:
          {
            style:
            {
              color: 'white'
            }
          }

        }],
      yAxis: [
        {
          gridLineColor: 'rgba(255, 255, 255, 0.1)',
          title:
          {
            text: 'Rainfall (mm)',
            style:
            {
              color: 'white'
            }
          },
          labels:
          {
            style:
            {
              color: 'white'
            }
          },

        },
        {
          gridLineColor: 'rgba(255, 255, 255, 0.1)',
          title:
          {
            text: 'volume',
            style:
            {
              color: 'white'
            }
          },
          labels:
          {
            style:
            {
              color: 'white'
            }
          },
          visible: false,
          opposite: true
        }
      ],
      tooltip: {
        shared: true,
        formatter() {
          return 'RfLevel: <b>' + this.y + ' mm</b>';
        }
      },
      legend: {
        itemStyle:
        {
          color: 'white'
        }
      },
      series: [
        //   {
        //     name: 'Date',

        //   },
        {
          name: 'Rainfall (mm)',
          type: 'column',
          color: '#1e88e5',
          data: object[0],
          tooltip: {
            valueSuffix: ''
          },
          marker: {
            enabled: true,
            radius: 2
          },
          borderWidth: 0
        }
      ],
      exporting: {
        enabled: false
      },
      credits: {
        enabled: false
      }

    };
    return options;
  }

  getLatestKnownTableData(): Observable<any> {
    return this.http.get<any>(this.API_URL + 'flowmanagement/realtime/root/3a7a18ff-8614-4c90-aa98-451b333df3d9').pipe(
      catchError(this.errorHandler.handleError('Kpi data request', []))
    );
  }

  getReservoirMetaData(basin: string): Observable<any> {
    return this.http.get<any>(this.API_URL + 'basinflowmetadata/' + basin).pipe(
      catchError(this.errorHandler.handleError('Kpi data request', []))
    );
  }

  getBasinTableDataNew(interval: string): Observable<any> {
    return this.http.get<any>(this.API_URL + 'flowmanagement/data/root/3a7a18ff-8614-4c90-aa98-451b333df3d9/view/' + interval).pipe(
      catchError(this.errorHandler.handleError('Kpi data request', []))
    );
  }

  getSettingsInfo(pointName): Observable<any> {
    return this.http.get<any>(this.API_URL + 'flowmanagement/settinginfo/3a7a18ff-8614-4c90-aa98-451b333df3d9/' + pointName).pipe(
      catchError(this.errorHandler.handleError('Kpi data request', []))
    );
  }

  updateSettingTabData(pointName, isRealtime, isVIC): Observable<any> {
    return this.http.get<any>(this.API_URL + 'flowmanagement/updatesettingdata/3a7a18ff-8614-4c90-aa98-451b333df3d9/' + pointName + '/realtime/' + isRealtime + '/lateral/' + isVIC).pipe(
      catchError(this.errorHandler.handleError('Kpi data request', []))
    );
  }

  getDateandTimeDashSeparatorNew(timestamp) {
    const d = new Date(timestamp);
    const year = d.getFullYear().toString();
    let month: any = d.getMonth() + 1;
    month = month.toString();
    let date = d.getDate().toString();
    let hours = d.getHours().toString();
    let minutes = d.getMinutes().toString();
    let seconds = d.getSeconds().toString();
    if (month.length < 2) { month = '0' + month; }
    if (date.length < 2) { date = '0' + date; }
    if (hours.length < 2) { hours = '0' + hours; }
    if (minutes.length < 2) { minutes = '0' + minutes; }
    if (seconds.length < 2) { seconds = '0' + seconds; }
    const str = year + '-' + month + '-' + date + ' ' + hours + ':' + minutes + ':' + seconds;
    return str;
  }

  getNDayListInFormat(referenceTS, noOfDays, offset) {
    if (referenceTS == null || referenceTS == undefined) {
      referenceTS = new Date().getTime();
    }
    const dayList = [];
    for (let i = offset; i < (noOfDays + offset); i++) {
      let day;
      const currDay = new Date(referenceTS + (i * 24 * 60 * 60 * 1000));
      const date = (currDay.getDate() > 9) ? currDay.getDate() : '0' + currDay.getDate();
      const month = ((currDay.getMonth() + 1) > 9) ? (currDay.getMonth() + 1) : '0' + (currDay.getMonth() + 1);
      const year = currDay.getFullYear();
      day = year.toString() + month.toString() + date.toString();
      dayList.push(day);
    }
    return dayList;
  }

  getHecHmsData(pUUID,pEUUID,type,startTs,endTs): Observable<any> {
    return this.http.get<any>(environment.url.KALESHWARAM_WRIS_API_URL+"glofas/"+pUUID+"/"+pEUUID+"/"+type+"/1651641361282/1655529361282").pipe(
      catchError(this.errorHandler.handleError('Kpi data request', []))
    );
  }

}


